import { Component, Inject, Injectable, LOCALE_ID, OnInit, ViewChild } from '@angular/core';
import { MatDateRangePicker } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormControl } from '@angular/forms';
import { time } from '../services/global-variables.service';
import { FormatWidth, getLocaleDateFormat } from '@angular/common';

// import { MatDatepicker, MatDateRangePicker } from '@angular/material/datepicker';

@Component({
    selector: 'lds-time-select',
    templateUrl: './time-select.component.html',
    styleUrls: ['./time-select.component.scss'],
    standalone: false
})
export class TimeSelectComponent implements OnInit {

  @ViewChild(MatDateRangePicker) picker: MatDateRangePicker<Date>;

  range = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });


  localeStr = ''

  constructor(
          private dialogRef: MatDialogRef<TimeSelectComponent>, 
          private dialog: MatDialog,
          @Inject( LOCALE_ID ) public locale: string
        ) { 

        this.localeStr = getLocaleDateFormat( this.locale, FormatWidth.Short );
  }

  ngOnInit() {
  }

  onCancel() {

    const result: TimeSelectResult = {
      timeSelected: false,
      startDate: undefined,
      endDate: undefined
    }

    this.dialogRef.close(result);
  }

  onConfirm() {
    const result: TimeSelectResult = {
      timeSelected: true,
      startDate: this.range.controls.start.value,
      endDate: this.range.controls.end.value
    }
    this.dialogRef.close(result);
  }

  open() {
    return this.dialog.open(TimeSelectComponent);
  }

  addPresetTime(timespan) {
    let maxDate = new Date();
    this.range.controls.end.setValue(maxDate);
    let startTime = maxDate.getTime();
    switch (timespan) {
      case "month-to-date":
        startTime = startTime - (30 * time.day);
        break;
      case "week-to-date":
        startTime = startTime - (7 * time.day);
        break;
      case "year-to-date":
        startTime = startTime - (365 * time.day);
    }
    this.range.controls.start.setValue(new Date(startTime));
  }

}

interface TimeSelectResult {
  timeSelected: boolean;
  startDate: Date;
  endDate: Date;
}
